import { useSelector } from 'react-redux';

import { RootState } from 'src/store/store';
import { hasPermission } from 'src/utils/permissions';

export function useAdminPermissions() {
  const { admin, permissions, loading, error, initialized } = useSelector(({ adminSession }: RootState) => adminSession);

  const can = (required?: string | string[]) => hasPermission(permissions, required);

  return {
    admin,
    permissions,
    loading,
    error,
    initialized,
    can,
  };
}
